import React from 'react';
import AuditTrailView from '../../components/auditTrail/AuditTrailView';

/** Admin system-wide audit trail (with project id filter). */
export default function AdminAuditTrailPage() {
  return (
    <AuditTrailView
      enableProjectFilter
      description="System-wide activity log across projects. Filter by project, module, event, actor, or date range. Super Admin role only."
    />
  );
}
